import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personHealthProfileApi } from '../../services/personHealthProfileApi';
import { UpdatePersonHealthProfile } from '../../dtos/PersonHealthProfiles/index';
import { personHealthProfileKeys } from './useGetPersonHealthProfile';
import { personKeys } from '../Person/useGetPerson';

export function useUpdatePersonHealthProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Omit<UpdatePersonHealthProfile, 'id'> }) =>
      personHealthProfileApi.update(id, data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully updated health profile');
        // Invalidate all personHealthProfile and person queries to refetch from server
        queryClient.invalidateQueries({ queryKey: personHealthProfileKeys.all });
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to update health profile'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to update health profile'}`);
    },
  });
}
